import {
  GET_NAME_REQUEST,
  GET_NAME_SUCCESS,
  GET_NAME_ERROR,
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_NAME_REQUEST:
      return {
        loading: true,
      };
    case GET_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_NAME_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
